<template>
<span
	class="d-flex flex-row flex-wrap ml-2"
	v-if="numAdults || numChildren"
	:class="additionalClasses"
>
	<template v-if="!displayWithIcons">
		<!-- ...existing code for non-icon display... -->
		<span>
			<span v-if="numAdults" class="numAdults text-capitalize">{{ numAdults }}&nbsp;</span>
			<span v-if="numAdults === 1" class="text-capitalize">{{ content.planner_resumeAdult }}</span>
			<span v-if="numAdults > 1" class="text-capitalize">{{ content.planner_resumeAdults }}</span>
			<template v-if="numAdults && numChildren">
				<span>,</span>
				&nbsp;
			</template>
		</span>
		<span>
			<span v-if="numChildren" class="numChildren text-capitalize">{{ numChildren }}&nbsp;</span>
			<span v-if="numChildren === 1" class="text-capitalize">{{ content.planner_resumeChild }}</span>
			<span v-if="numChildren > 1" class="text-capitalize">{{ content.planner_resumeChildren }}</span>
		</span>
	</template>
	<template v-else>
		<span class="caption text-grey-700 d-flex align-items-center">
			<!-- Only show participants and parenthesis if not 'night' or 'home' (en_US) -->
			<template v-if="optionName !== 'night' && !(optionName === 'home' && store.getters.locale === 'en_US')">
				{{ "(" }}
				<span v-if="numAdults">
					<span>{{ numAdults }}</span>
					<svg
						:height="iconSize_adult"
						:width="iconSize_adult"
						class="icon"
						style="margin-bottom: 2px"
					>
						<use xlink:href="#___icon___person"></use>
					</svg>
				</span>
				<span v-if="numChildren">
					{{ "+" }}
					<span>{{ numChildren }}</span>
					<svg :height="iconSize_child" :width="iconSize_child" class="icon">
						<use xlink:href="#___icon___person"></use>
					</svg>
				</span>
				<!-- Default: show skipass or service duration and days -->
				<span v-if="optionName !== 'transport' && optionName !== 'flight' && isServiceToDisplayDuration(optionName || '')">
					, {{ props.variant?.skipass }} {{ content.days }}
				</span>
				{{ ")" }}
			</template>
			<!-- For 'home' (en_US) show skipass+1 nights only -->
			<template v-else-if="optionName === 'home' && store.getters.locale === 'en_US'">
				{{ `(${Math.min(Number(props.variant?.skipass), 7) || ''} ${content.planner_nights})` }}
			</template>
			<!-- For 'night' show nothing -->
			<template v-else></template>
		</span>
	</template>
	</span>
</template>

<script setup lang="ts">
import { computed, watch, ref } from 'vue'
import type { Ref } from 'vue'
import iconSizes from "@/config/iconSizes"
import { isServiceToDisplayDuration } from "@/vue/planning/logic/isServiceToDisplayDuration"
import { isCS } from "@/vue/planning/logic/cs"
// import getServiceDuration from "@/vue/planning/logic/getServiceDuration"
import store from '@/vue/planning/store/store'

// Props
interface Props {
	participants: number[]
	content: { [key: string]: string }
	excludedAges?: number[]
	optionName?: string | null
	variant?: { [key: string]: any } | null
	displayWithIcons?: boolean
	additionalClasses?: string
}

const props = withDefaults(defineProps<Props>(), {
	participants: () => [],
	content: () => ({}),
	excludedAges: () => [],
	optionName: '',
	variant: null,
	displayWithIcons: false,
	additionalClasses: ''
})

// Computed
const filteredParticipants = computed(() => {
	return props.participants.filter((age) => !props.excludedAges.includes(age))
})

const displayDuration = computed(() => {
	if (!props.optionName || props.optionName === 'transport') return ''
	return props.variant?.skipass
})

const numAdults = computed(() => {
	return filteredParticipants.value.filter((age) => age >= 18).length
})

const numChildren = computed(() => {
	return filteredParticipants.value.filter((age) => age < 18).length
})

const iconSize_adult = computed(() => iconSizes.l)
const iconSize_child = computed(() => iconSizes.s)
</script>

<style scoped>
.text-capitalize {
	text-transform: capitalize;
}
</style>
